import produce, { Draft } from 'immer';
import { getType } from 'typesafe-actions';

import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { ResourceType } from '../common/typings';

import { changeValue, closeModal, openModal, showLinkErrors, uploadByLink, UploadByLinkModalAction } from './actions';
import { UploadByLinkModalState } from './typings';

const DEFAULT_ERRORS: ErrorItem[] = [];

export const uploadByLinkModalInitialState = {
    isVisible: false,
    isLoading: false,
    errors: DEFAULT_ERRORS,
    urlType: ResourceType.video,
    value: '',
    editorId: ''
};

export function uploadByLinkModal(
    state: UploadByLinkModalState = uploadByLinkModalInitialState,
    action: UploadByLinkModalAction
): UploadByLinkModalState {
    return produce(state, (draft: Draft<UploadByLinkModalState>) => {
        switch (action.type) {
            case getType(openModal): {
                const { urlType, fileEditorId } = action;

                draft.isVisible = true;
                draft.editorId = fileEditorId;
                draft.urlType = urlType;

                return;
            }

            case getType(closeModal): {
                draft.isVisible = false;
                draft.isLoading = false;
                draft.errors = DEFAULT_ERRORS;
                draft.value = '';

                return;
            }

            case getType(changeValue): {
                draft.value = action.value;
                draft.errors = DEFAULT_ERRORS;

                return;
            }

            case getType(showLinkErrors): {
                draft.errors = action.errors;
                draft.isLoading = false;

                return;
            }

            case getType(uploadByLink): {
                draft.errors = DEFAULT_ERRORS;
                draft.isLoading = true;

                return;
            }

            default:
                return state;
        }
    });
}
